export default "__VITE_ASSET__B9oUP5fH__"